import { strTrim } from '@/utils';

/*
 *
 * @description 根据产品id获取对比数据
 * @param {string} pid
 * @return {object} data
 * @time 2022/2/20 11:47 上午
 *
 */
function getProductCompareConfig({ pid, LANG, country = {} }) {
  let data = null;
  const { code, X_Language } = country;
  let arr = [];

  // 参数长度
  let parameterLen = 0;
  let ThumpListMap = {};

  const getDesc = (d) => {
    const t = d.trim?.()?.toLowerCase();

    if (t === 'yes') {
      const hookPic = (
        <svg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M34.0518 14.947C34.5358 15.4311 34.5358 16.2159 34.0518 16.6999L19.7356 31.0161C19.2516 31.5002 18.4668 31.5002 17.9827 31.0161L11.4753 24.5088C10.9913 24.0247 10.9913 23.2399 11.4753 22.7558C11.9594 22.2718 12.7442 22.2718 13.2283 22.7558L18.8592 28.3867L32.2989 14.947C32.7829 14.463 33.5677 14.463 34.0518 14.947Z'
            fill='#e2e2e2'
          />
        </svg>
      );
      return hookPic;
    }

    return d;
  };

  switch (pid) {
    case 12:
      data = {
        type: 'image',
        ratio: {
          pc: {
            zh_cn: [1200, 2344],
            zh_tw: [1200, 2341],
            en_us: [1200, 2336],
            de_de: [1200, 2336],
            es_es: [1200, 2336],
            ja_jp: [1200, 2329],
            ko_kr: [1200, 2331],
            fr_fr: [1200, 2336],
            it_it: [1200, 2336],
          },
          mob: {
            zh_cn: [750, 2836],
            zh_tw: [750, 2812],
            en_us: [750, 2846],
            de_de: [750, 2942],
            es_es: [750, 2906],
            ja_jp: [750, 2848],
            ko_kr: [750, 2856],
            fr_fr: [750, 2846],
            it_it: [750, 2906],
          },
        },
        val: {
          pc: {
            zh_cn: 'https://res.insta360.com/static/assets/storage/20201231/deadea6ef22d767b868dc66ca6a7f4a9/SC.jpg',
            zh_tw: 'https://res.insta360.com/static/assets/storage/20201231/2861b8c2d20efed7aa55e5dbb1d5c3fb/TC.jpg',
            en_us: 'https://res.insta360.com/static/assets/storage/20201231/c084ba93c1fe70e4dc3c209afd2ae4db/EN.jpg',
            de_de: 'https://res.insta360.com/static/assets/storage/20201231/9d05d743e7c805d4568701a5be488420/DE.jpg',
            es_es: 'https://res.insta360.com/static/assets/storage/20201231/c026450d3ee550cccbd8231b3e5c7dfb/ES.jpg',
            ja_jp: 'https://res.insta360.com/static/assets/storage/20201231/d5bdf13948f5c8e637547ff1a437d3dd/JP.jpg',
            ko_kr: 'https://res.insta360.com/static/assets/storage/20201231/b044c7b7371feb4b9cef48d33936026a/KR.jpg',
            fr_fr: 'https://res.insta360.com/static/assets/storage/20201231/db4f0e2ab28564d7f4dbfe5fdb418b27/FR.jpg',
            it_it: 'https://res.insta360.com/static/assets/storage/20201231/4c8503acaa00be3f2bb9d216d0b35d9a/IT.jpg',
          },
          mob: {
            zh_cn: 'https://res.insta360.com/static/assets/storage/20201231/4e39248ca27be371d88e20efd7ee80b7/SC.jpg',
            zh_tw: 'https://res.insta360.com/static/assets/storage/20201231/192db42f3dd2b7e4decd10aea372eb5d/TC.jpg',
            en_us: 'https://res.insta360.com/static/assets/storage/20201231/3d26d0af68e95d0953e908643b6a2167/EN.jpg',
            de_de: 'https://res.insta360.com/static/assets/storage/20201231/58c04a6a384f20f30096c873c4a1c4ed/DE.jpg',
            es_es: 'https://res.insta360.com/static/assets/storage/20201231/c498635d24ad1954764f5a38b4e89016/ES.jpg',
            ja_jp: 'https://res.insta360.com/static/assets/storage/20201231/d840a860234b2ead69c85e3149cb9ffd/JP.jpg',
            ko_kr: 'https://res.insta360.com/static/assets/storage/20201231/8888dc58f06cadd76b4d316e9a2dfd93/KR.jpg',
            fr_fr: 'https://res.insta360.com/static/assets/storage/20201231/51e257945c5d2739c110f5c2beea77ff/FR.jpg',
            it_it: 'https://res.insta360.com/static/assets/storage/20201231/9dac14fde2cf141443e1f0e0a4bd6460/IT.jpg',
          },
        },
      };
      break;
    // case 13:
    //   data = {
    //     type: 'image',
    //     ratio: {
    //       pc: {
    //         zh_cn: [1200, 2344],
    //         zh_tw: [1200, 2341],
    //         en_us: [1200, 2336],
    //         de_de: [1200, 2336],
    //         es_es: [1200, 2336],
    //         ja_jp: [1200, 2329],
    //         ko_kr: [1200, 2331],
    //         fr_fr: [1200, 2336],
    //         it_it: [1200, 2336],
    //       },
    //       mob: {
    //         zh_cn: [750, 2836],
    //         zh_tw: [750, 2812],
    //         en_us: [750, 2846],
    //         de_de: [750, 2942],
    //         es_es: [750, 2906],
    //         ja_jp: [750, 2848],
    //         ko_kr: [750, 2856],
    //         fr_fr: [750, 2846],
    //         it_it: [750, 2906],
    //       },
    //     },
    //     val: {
    //       pc: {
    //         zh_cn: 'https://res.insta360.com/static/assets/storage/20201231/343cff55630f2514e5f63af6c17e69a9/SC.jpg',
    //         zh_tw: 'https://res.insta360.com/static/assets/storage/20201231/7a22aa27cddb52637ea111ee058bb88e/TC.jpg',
    //         en_us: 'https://res.insta360.com/static/assets/storage/20201231/7fe44096311d752d498664177d3c2ed3/EN.jpg',
    //         de_de: 'https://res.insta360.com/static/assets/storage/20201231/54f098f0b10f3c114c2598dae3113a38/DE.jpg',
    //         es_es: 'https://res.insta360.com/static/assets/storage/20201231/0a7c166109e3c8ad6dae975a274b6fee/ES.jpg',
    //         ja_jp: 'https://res.insta360.com/static/assets/storage/20201231/096bdb7218c4b7e5dcf97c14baf542e2/JP.jpg',
    //         ko_kr: 'https://res.insta360.com/static/assets/storage/20201231/e36ac98bcd64df12fc6bfc5501b34e67/KR.jpg',
    //         fr_fr: 'https://res.insta360.com/static/assets/storage/20201231/b5f970cae946a817bf5751a4d77d7682/FR.jpg',
    //         it_it: 'https://res.insta360.com/static/assets/storage/20201231/1b021d668c8a0cb7f2413f157930bdc4/IT.jpg',
    //       },
    //       mob: {
    //         zh_cn: 'https://res.insta360.com/static/assets/storage/20201231/a68154f15b8eab9bf6dc9a96d8b2e7c0/SC.jpg',
    //         zh_tw: 'https://res.insta360.com/static/assets/storage/20201231/8291751d8bc3c64baa7b10c4f5648acd/TC.jpg',
    //         en_us: 'https://res.insta360.com/static/assets/storage/20201231/90d137e732ea3105b4e057d2f1a813bf/EN.jpg',
    //         de_de: 'https://res.insta360.com/static/assets/storage/20201231/b941ccba36aa446ebc6829f56c7e714c/DE.jpg',
    //         es_es: 'https://res.insta360.com/static/assets/storage/20201231/4a82250836bd2b687f681245f56004ff/ES.jpg',
    //         ja_jp: 'https://res.insta360.com/static/assets/storage/20201231/deb8ca6446d95056866e621da3750d02/JP.jpg',
    //         ko_kr: 'https://res.insta360.com/static/assets/storage/20201231/7ca70a0b942eb4b109ace5e7e3773085/KR.jpg',
    //         fr_fr: 'https://res.insta360.com/static/assets/storage/20201231/b15f92d39604d50ad3bf92fb6eb714c7/FR.jpg',
    //         it_it: 'https://res.insta360.com/static/assets/storage/20201231/3ff8c8e1862e7e69583e7a2e9a6914ef/IT.jpg',
    //       },
    //     },
    //   };
    //   break;
    case 14:
      data = {
        type: 'custom',
        val: {
          title: {
            pc: [
              {
                id: 1,
                product_name:
                  code === 'CN'
                    ? 'https://res.insta360.com/static/infr_base/8e91ed9856156c5f1ce78791172518b9/Frame%203.png'
                    : 'https://res.insta360.com/static/assets/storage/20210315/dae1a74a6fe1b14e1f850a206c7daacf/GO2_logo_pc_2x.png',
                url: 'https://res.insta360.com/static/assets/storage/20210315/c782a628d440ffb1e739a5ed72f0df54/%E5%88%87%E7%89%87_2x.png',
              },
              {
                id: 2,
                product_name:
                  code === 'CN'
                    ? 'https://res.insta360.com/static/infr_base/b27cf7f5e297cb8e95cfa7a6788e0e32/Frame%204.png'
                    : 'https://res.insta360.com/static/assets/storage/20210315/910f2b76df45bc547c2993726ea0e2fd/GO_logo_pc_2x.png',
                url: 'https://res.insta360.com/static/assets/storage/20210315/fcca4fd30526ad155a60789305ca0e52/GO_2x.png',
              },
            ],
            mob: [
              {
                id: 1,
                product_name:
                  code === 'CN'
                    ? 'https://res.insta360.com/static/infr_base/8e91ed9856156c5f1ce78791172518b9/Frame%203.png'
                    : 'https://res.insta360.com/static/assets/storage/20210315/3c000f25832931845be8e64c15782b8e/GO2_logo_mo_2x.png',
                url: 'https://res.insta360.com/static/assets/storage/20210315/ad1cd8b802e20db4fa46d98d710cb81b/GO2_%E5%85%85%E7%94%B5%E7%9B%92%E5%A4%87%E4%BB%BD_2x.png',
              },
              {
                id: 2,
                product_name:
                  code === 'CN'
                    ? 'https://res.insta360.com/static/infr_base/b27cf7f5e297cb8e95cfa7a6788e0e32/Frame%204.png'
                    : 'https://res.insta360.com/static/assets/storage/20210315/2cf602ab45b547bb8abcd8c95ae1d7f3/GO_logo_mo_2x.png',
                url: 'https://res.insta360.com/static/assets/storage/20210315/d291fce74fb2588ad21328d16690fbb3/GO_150w_2x.png',
              },
            ],
          },
          params: [
            {
              name: LANG['product.p_go2.compare.sensor.name'],
              val: [LANG['product.p_go2.compare.sensor.go_2'], LANG['product.p_go2.compare.sensor.go']],
            },
            {
              name: LANG['product.p_go2.compare.lens_protector.name'],
              val: [LANG['product.p_go2.compare.lens_protector.go_2'], LANG['product.p_go2.compare.lens_protector.go']],
            },
            {
              name: LANG['product.p_go2.compare.hdr_video.name'],
              val: [LANG['product.p_go2.compare.hdr_video.go_2'], LANG['product.p_go2.compare.hdr_video.go']],
            },
            {
              name: LANG['product.p_go2.compare.wifi_prefview_transmission.name'],
              val: [
                LANG['product.p_go2.compare.wifi_prefview_transmission.go_2'],
                LANG['product.p_go2.compare.wifi_prefview_transmission.go'],
              ],
            },
            {
              name: LANG['product.p_go2.compare.wearable_desgin_upgrades.name'],
              val: [
                LANG['product.p_go2.compare.wearable_desgin_upgrades.go_2'],
                LANG['product.p_go2.compare.wearable_desgin_upgrades.go'],
              ],
            },
            {
              name: LANG['product.p_go2.compare.chargingbox_function.name'],
              val: [
                LANG['product.p_go2.compare.chargingbox_function.go_2'],
                LANG['product.p_go2.compare.chargingbox_function.go'],
              ],
            },
            {
              name: LANG['product.p_go2.compare.image_stabilization.name'],
              val: [
                LANG['product.p_go2.compare.image_stabilization.go_2'],
                LANG['product.p_go2.compare.image_stabilization.go'],
              ],
            },
            {
              name: LANG['product.p_go2.compare.more_view_available.name'],
              val: [
                LANG['product.p_go2.compare.more_view_available.go_2'],
                LANG['product.p_go2.compare.more_view_available.go'],
              ],
            },
            {
              name: LANG['product.p_go2.compare.maximum_length_of_a_single_shoot.name'],
              val: [
                LANG['product.p_go2.compare.maximum_length_of_a_single_shoot.go_2'],
                LANG['product.p_go2.compare.maximum_length_of_a_single_shoot.go'],
              ],
            },
            {
              name: LANG['product.p_go2.compare.wateproof.name'],
              val: [LANG['product.p_go2.compare.wateproof.go_2'], LANG['product.p_go2.compare.wateproof.go']],
            },
            {
              name: LANG['product.p_go2.compare.image_qulity.name'],
              val: [LANG['product.p_go2.compare.image_qulity.go_2'], LANG['product.p_go2.compare.image_qulity.go']],
            },
            {
              name: LANG['product.p_go2.compare.life.name'],
              val: [LANG['product.p_go2.compare.life.go_2'], LANG['product.p_go2.compare.life.go']],
            },
            {
              name: LANG['product.p_go2.compare.weight.name'],
              val: [LANG['product.p_go2.compare.weight.go_2'], LANG['product.p_go2.compare.weight.go']],
            },
            {
              name: LANG['product.p_go2.compare.memory.name'],
              val: [
                // 针对香港（英文）、新加坡、泰国 的名称有变化
                LANG['product.p_go2.compare.memory.go_2'],
                LANG['product.p_go2.compare.memory.go'],
              ],
            },
          ],
        },
      };
      break;
    case 15:
      data = {
        type: 'fromLANG',
        moreDetailLink: 'https://www.insta360.com/product/compare',
        valKeys: [],
        val: [
          {
            'title': '此行放产品图链接',
            'one_rs':
              code === 'CN'
                ? 'https://res.insta360.com/static/cc1054e9ac89c914ecbfec58281845ce/%E5%AF%B9%E6%AF%94%E9%A1%B5%E4%B8%AD%E6%96%87RS.png'
                : 'https://res.insta360.com/static/fa909208624bc55ae21948e32b678d62/%E5%AF%B9%E6%AF%94%E9%A1%B5RS.png',
            'one_r':
              code === 'CN'
                ? 'https://res.insta360.com/static/47a023e712de5fe41a23fc8853a898b5/%E5%AF%B9%E6%AF%94%E9%A1%B5%E4%B8%AD%E6%96%87R.png'
                : 'https://res.insta360.com/static/3957c25021d9fa6dafeb862e0858d315/%E5%AF%B9%E6%AF%94%E9%A1%B5R.png',
          },
          ...JSON.parse(LANG['product.one_rs.comparison.val_new']),
        ],
        remark: '产品对比',
      };
      break;
    case 21:
    case 617:
      // 617房产套餐分销商Proptechlabs的对比模块去掉第一行参数
      parameterLen = pid === 617 ? 8 : 9;
      let startIndex = pid === 617 ? 2 : 1;
      arr = new Array(parameterLen).fill([]).map((item, i) => {
        return {
          title: LANG[`product.virtualTour.compare.t${i + startIndex}`],
          // rs1Inch: LANG[`product.virtualTour.compare.v${i + 1}_rs1Inch`],
          x4: LANG[`product.virtualTour.compare.v${i + startIndex}_x4`],
          x3: LANG[`product.virtualTour.compare.v${i + startIndex}_x3`],
          x2: LANG[`product.virtualTour.compare.v${i + startIndex}_x2`],
        };
      });
      ThumpListMap = {
        // rs1Inch: {
        //   zh_cn: '',
        //   zh_tw: 'https://res.insta360.com/static/45bda50668acd77583dee3f0cfab18e1/PC-TC.png',
        //   en_us: 'https://res.insta360.com/static/fe381b2ae2ce86358fd69c7cf8e0ec57/PC-EN.png',
        //   ko_kr: 'https://res.insta360.com/static/097abd36bf14447a2de165d7cbf419a9/PC-KR.png',
        //   de_de: 'https://res.insta360.com/static/fe381b2ae2ce86358fd69c7cf8e0ec57/PC-EN.png',
        //   ja_jp: 'https://res.insta360.com/static/a5b88968790d71afb0f1164553e02459/PC-JP.png',
        //   es_es: 'https://res.insta360.com/static/fe381b2ae2ce86358fd69c7cf8e0ec57/PC-EN.png',
        //   fr_fr: 'https://res.insta360.com/static/fe381b2ae2ce86358fd69c7cf8e0ec57/PC-EN.png',
        //   it_it: 'https://res.insta360.com/static/fe381b2ae2ce86358fd69c7cf8e0ec57/PC-EN.png',
        // },
        x4: {
          default: 'https://res.insta360.com/static/6a69b004abd98ecc042cc63e8cc13c59/Frame%20626690.png',
        },
        x3: {
          default: 'https://res.insta360.com/static/b86839dcd467d5d2103d6e6d1ebbcf8d/PC%20X3.png',
        },
        x2: {
          default: 'https://res.insta360.com/static/c40c25e1d88988bf386b559f5c300e67/PC%20X2.png',
        },
      };
      data = {
        type: 'fromLANG',
        moreDetailLink: 'https://www.insta360.com/product/compare',
        hideOnlyDiffSwitch: true,
        valKeys: [],
        val: [
          {
            title: '此行放产品图链接',
            // rs1Inch: ThumpListMap.rs1Inch[X_Language],
            x4: ThumpListMap.x4.default,
            x3: ThumpListMap.x3.default,
            x2: ThumpListMap.x2.default,
          },
          ...arr,
        ],
        remark: '产品对比',
      };
      break;
    case 225:
      parameterLen = 9;

      arr = new Array(parameterLen).fill([]).map((item, index) => {
        const i = index + 1;
        return {
          title: LANG[`product.propertyPackag.title.title_${i}`],
          x2: getDesc(LANG[`product.propertyPackag.second.t_${i}`]),
          x3: getDesc(LANG[`product.propertyPackag.first.t_${i}`]),
        };
      });
      data = {
        type: 'fromLANG',
        moreDetailLink: 'https://www.insta360.com/product/compare',
        hideOnlyDiffSwitch: true,
        valKeys: [],
        val: [
          {
            'title': '此行放产品图链接',
            'x3': LANG[`product.propertyPackag.first.img`],
            'x2': LANG[`product.propertyPackag.second.img`],
          },
          ...arr,
        ],
        remark: '产品对比',
      };
      break;
    case 23:
      parameterLen = 5; // 5个对比参数
      arr = new Array(parameterLen).fill([]).map((item, index) => {
        const i = index + 1;
        return {
          title: LANG[`product.ConstructionKit.compare.t${i}`],
          x4: LANG[`product.ConstructionKit.compare.t${i}_x4`],
          x3: LANG[`product.ConstructionKit.compare.t${i}_x3`],
          // rs: LANG[`product.ConstructionKit.compare.t${i}_rs`],
        };
      });
      const ThumbMap = {
        // RS: {
        //   zh_cn: '',
        //   zh_tw: 'https://res.insta360.com/static/d5dee41003fab16e012754edc6a01712/RS-TC.png',
        //   en_us: 'https://res.insta360.com/static/050eb4577fc3ade6384c12540de66a6a/RS-EN.png',
        //   ko_kr: 'https://res.insta360.com/static/358a96af80b35ad9a113d15327779743/compare_RS_KR.png',
        //   de_de: 'https://res.insta360.com/static/c08ebdaee9779422c327f05634e319bc/compare_RS_DE.png',
        //   ja_jp: 'https://res.insta360.com/static/171c92b4027d5174332aa86d4aa13010/RS-JP.png',
        //   es_es: 'https://res.insta360.com/static/ab40de2714f1bbce338c4b263bff6776/compare_RS_ES.png',
        //   fr_fr: 'https://res.insta360.com/static/dffd46adb7e446cc0c62187fb015bb9e/compare_RS_FR.png',
        //   it_it: 'https://res.insta360.com/static/fcffda93bd5ff17aea266a2f014b6d70/compare_RS_IT.png',
        // },
        X3: {
          zh_cn: '',
          zh_tw: 'https://res.insta360.com/static/2f3c86d23e540eaa26d6a6fc3f99d36d/TC-x3.jpg',
          en_us: 'https://res.insta360.com/static/234adec6eaab52700893604ddece6939/EN-x3.jpg',
          ko_kr: 'https://res.insta360.com/static/906a90b76431cdf48530f40f9b670d6f/KR-x3.jpg',
          de_de: 'https://res.insta360.com/static/aa1ff1da2d7d7cc4547b75413c84829c/DE-x3.jpg',
          ja_jp: 'https://res.insta360.com/static/79a9041e7d39757fa2aad93f7a3dc0c5/JP-x3.jpg',
          es_es: 'https://res.insta360.com/static/5b980ca78bae0c6b2bc693e873a10a71/ES-x3.jpg',
          fr_fr: 'https://res.insta360.com/static/3e89079873e57b27ae391228902154a5/FR-x3.jpg',
          it_it: 'https://res.insta360.com/static/4fd0cc251a339ce52ebe7e7a0d6c8cb2/IT-x3.jpg',
        },
        X4: {
          zh_cn: '',
          zh_tw: 'https://res.insta360.com/static/8058933161e6702c2badd2364892f31c/TC-x4.jpg',
          en_us: 'https://res.insta360.com/static/5a7bd291a189410c01e8a0a055bcfd21/EN-x4.jpg',
          ko_kr: 'https://res.insta360.com/static/e087586f57ee724648a22c96745a4f3a/KR-x4.jpg',
          de_de: 'https://res.insta360.com/static/8ecd399fa253dd48a712ce8515580145/DE-x4.jpg',
          ja_jp: 'https://res.insta360.com/static/f7507a92bfa32f56f3473e7119baef4a/JP-x4.jpg',
          es_es: 'https://res.insta360.com/static/0c4de346392708a91d2360e10a49139f/ES-x4.jpg',
          fr_fr: 'https://res.insta360.com/static/c30b0cebd5a34e070969abcd10bea343/FR-x4.jpg',
          it_it: 'https://res.insta360.com/static/b4c6e0cef6d04c9a1d9afff2f7855f17/IT-x4.jpg',
        },
      };
      data = {
        type: 'fromLANG',
        moreDetailLink: 'https://www.insta360.com/product/compare',
        hideOnlyDiffSwitch: true,
        valKeys: [],
        val: [
          {
            'title': '此行放产品图链接',
            'x4': ThumbMap.X4[X_Language],
            'x3': ThumbMap.X3[X_Language],
            // 'rs': ThumbMap.RS[X_Language],
          },
          ...arr,
        ],
        remark: '产品对比',
      };
      break;
    case 24:
      const paramNum = 11;
      const paramArr = new Array(paramNum).fill([]).map((item, index) => {
        const i = index + 1;
        return {
          title: LANG[`product.go3.compare.c_t_${i}`],
          go3: LANG[`product.go3.compare.c_t_${i}_1`],
          go2: LANG[`product.go3.compare.c_t_${i}_2`],
        };
      });

      const GOMap = {
        GO3: {
          en_us: 'https://res.insta360.com/static/d1c2410bdc001de93f67a93c8a299d7b/GO%203%20EN.png',
          zh_cn: 'https://res.insta360.com/static/86fc07180831d8c9436b06ad61545660/GO%203%20SC.png',
        },
        GO2: {
          en_us: 'https://res.insta360.com/static/7918cb031829f8e0b0ba16d9a7bee018/GO%202%20EN.png',
          zh_cn: 'https://res.insta360.com/static/f3c541884ba61c9cca66a23d5137c259/GO%202%20SC.png',
        },
      };

      data = {
        type: 'fromLANG',
        moreDetailLink: 'https://www.insta360.com/product/compare',
        val: [
          {
            'title': '此行放产品图链接',
            'go3': GOMap.GO3[X_Language] ?? GOMap.GO3.en_us,
            'go2': GOMap.GO2[X_Language] ?? GOMap.GO2.en_us,
          },
          ...paramArr,
        ],
        remark: '产品对比',
        hideOnlyDiffSwitch: true,
        valStyle: {
          wordBreak: 'break-word',
        },
      };
      break;
    default:
  }

  try {
    if (data?.type === 'fromLANG') {
      const val = data['val'];
      const valKeys = Object.keys(val[0]).filter((o) => o !== 'title'); // 需要显示到客户端的key值
      data.valKeys = valKeys;

      // 过滤内容不存在的行
      data.val = data.val.filter((row) => !!valKeys.find((key) => !!row[key]));

      val.forEach((row) => {
        row.hasSameValue = true; // 所有值是否都相同
        const firstRowKeyVal = strTrim(row[valKeys[0]]).toLowerCase();
        valKeys.forEach((key) => {
          const rowKeyVal = strTrim(row[key]).toLowerCase();
          if (rowKeyVal !== firstRowKeyVal) {
            row.hasSameValue = false;
          }
        });
      });
    }
    return data;
  } catch (e) {
    console.error('封装产品对比数据失败', e);
    return null;
  }
}

export default {
  getProductCompareConfig,
};
